import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import CreateNewSessionModal from "../Resource/Popup/CreateSessionPopup";
import ToggleTabs from "./ChartTableToggle";
import {useNavigate } from "react-router-dom";
const DataTabs = [
  // { label: "Power", step: 0, tab: "power" },
  { label: "Simulation", step: 1, tab: "simulation" },
  { label: "Optimal", step: 2, tab: "optimal" },
  { label: "Metrics", step: 3, tab: "metrics" },
];

export default function SimulationModHeader({
  title,
  tabsShow = false,
  refreshKey,
  setRefreshKey,
  activeTab: activeTabProp, // ✅ new prop
  setActiveTab: setActiveTabProp, // ✅ new prop
}: {
  title: string;
  tabsShow?: boolean;
  activeTab?: string;
  refreshKey: any;
  setRefreshKey: any; 
  setActiveTab?: (tab: string) => void; // external setter
}) {
  const tabNames = useSelector((state: any) => state.switchTabs.tabNames);
  const location = useLocation();
  const [activeTabInternal, setActiveTabInternal] = useState<string>();
  const [isModalOpen, setModalOpen] = useState(false);
  const navigate = useNavigate();

  // Decide which source to use: prop vs local state
  const activeTab = activeTabProp ?? activeTabInternal;
  const setActiveTab = setActiveTabProp ?? setActiveTabInternal;

  // useEffect(() => {
  //   const currentTab = DataTabs.find((tab) =>
  //     location.pathname.includes(tab)
  //   );
  //   if (currentTab) {
  //     setActiveTab(currentTab.label);
  //   }
  // }, [location.pathname, setActiveTab]);

  // useEffect(() => {
  //   if (activeTab === "GENERATION") {
  //     navigate("/demo/merit_engine/simulation-generation");
  //   } else if (activeTab === "COST") {
  //     navigate("/demo/merit_engine/simulation-cost");
  //   } else if (activeTab === "BID") {
  //     navigate("/demo/merit_engine/simulation-bid");
  //   }
  // }, [activeTab, navigate]);

  return (
    <div className="bg-white p-[0.5rem] rounded-2xl flex flex-wrap gap-3 justify-between items-center border-[0.5px] border-[#DFEAF2]">
      <div className="flex items-center gap-4">
        <button
          onClick={() => setModalOpen(true)}
          className=" w-[189px]  h-[37px] flex items-center justify-center gap-1 text-xs rounded-xl p-3 bg-[#FFFAF6] text-[#F1935C] font-medium border border-[#F1935C] hover transition transform hover:scale-105"
        >
          + <span>Create a New Session</span>
        </button>
      </div>
      <h2 className="chartHeading !text-base !font-medium w-100 text-[#34656D]">{title}</h2>
      {tabsShow ? (
        <>
          {DataTabs.length === 1 ? (
            <div className="tab tab-active rounded-lg"></div>
          ) : (
            <ToggleTabs
              activeNavigation={true}
              tabs={DataTabs.map((tab) => tab.label)}
              activeTab={activeTab ?? DataTabs[0].label}
              setActiveTab={setActiveTab}
            />
          )}
        </>
      ) : (
        <div className="w-44"></div>
      )}
      <CreateNewSessionModal
        isOpen={isModalOpen}
        onClose={() => {
          setModalOpen(false);
          setRefreshKey((prev: any) => prev + 1);
        }}
      />
    </div>
  );
}
